module.exports = __webpack_public_path__ + "media/signup-react/sephore-second-e2de0740.png";